import Link from 'next/link';
import { Collection } from '@/sanity/schemaTypes/documents/collection';
import { absoluteUrl } from '@/lib/utils';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid';

export default function Breadcrumb({
  collection,
  currentPage
}: {
  collection: Collection;
  currentPage?: string;
}) {
  return (
    <nav aria-label="Breadcrumb" className="mx-auto max-w-7xl px-3 text-sm sm:px-6 lg:px-8">
      <ol className="flex flex-wrap items-center space-x-3 gap-y-2">
        <li className="text-sm">
          <div className="flex items-center">
            <Link href="/" className="mr-3 font-medium text-gray-700 hover:text-gray-900">
              <span className="sr-only">Home</span>
              <HomeIcon className="h-4 w-auto" aria-hidden="true" />
            </Link>
            <ChevronRightIcon className="h-3 w-auto text-gray-400" aria-hidden="true" />
          </div>
        </li>
        <Crumb collection={collection} last={currentPage === undefined} />
        {currentPage && <li className="text-sm text-gray-700">{currentPage}</li>}
      </ol>
    </nav>
  );
}

function Crumb({ collection, last }: { collection: Collection; last?: boolean }) {
  return (
    <>
      {collection.parent && <Crumb collection={collection.parent} />}
      <li>
        <div className="flex items-center">
          <Link
            href={absoluteUrl(collection.slug)}
            className="mr-3 text-sm font-medium text-gray-700 hover:text-gray-900"
          >
            {collection.title}
          </Link>
          {!last && <ChevronRightIcon className="h-3 w-auto text-gray-400" aria-hidden="true" />}
        </div>
      </li>
    </>
  );
}
